module.exports = __webpack_public_path__ + "img/apple.56d51ff6.png";